import Vue from 'vue';

document.addEventListener("DOMContentLoaded", function () {

    if (document.getElementById("newslist") !== null) {

        var news = [];
        
        if (document.getElementById("newsJson") !== null) {
            news = JSON.parse(document.getElementById("newsJson").textContent);
            news.forEach(function (n) {
                n.newsPublicationDate = new Date(n.newsPublicationDate);
            });
        }

        var app = new Vue({
            el: "#newslist",
            data: {
                news: news,
                start: 0,
                pageSize: 6,
                category: "all",
                region: "all",
                year: "all",
                month: "-1",
                length: 0,
                activeButton: 1
            },
            computed: {
                items: function () {
                    var category = this.category;
                    var region = this.region;
                    var year = this.year;
                    var month = this.month;

                    var filtered = this.news.filter(function (n) {

                        var retVal = category === "all" || n.categories.indexOf(category) > -1;

                        retVal = retVal && (region === "all" || n.regions.indexOf(region) > -1);


                        if (year != "all") {
                            retVal = retVal && (n.newsPublicationDate.getFullYear() == year);
                            if (month != "-1")
                                retVal = retVal && (n.newsPublicationDate.getMonth() == month);
                        }
                        return retVal;
                    });
                    this.length = filtered.length;
                    return filtered.slice(this.start, this.start + this.pageSize);
                }
            },
            methods: {
                page: function (event) {
                    var text = event.target.textContent;
                    if (text == "Prev") {
                        --this.activeButton;
                        this.activeButton = Math.max(1, this.activeButton);
                    }
                    else if (text == "Next") {
                        ++this.activeButton;
                        this.activeButton = Math.min(Math.ceil(this.length / this.pageSize), this.activeButton);
                    }
                    else {
                        this.activeButton = parseInt(event.target.textContent);
                    }

                    this.start = (this.activeButton - 1) * this.pageSize;
                    event.preventDefault();
                }
            }
        });

    }


    if (document.getElementById("applyButton") !== null) {
        document.getElementById("applyButton").addEventListener("click", function () {
            app.start = 0;
            app.category = document.getElementById("categorySelect").value;
            app.region = document.getElementById("regionSelect").value;
            var dateRange = document.getElementById("monthSelect");
            if (dateRange.value == "all") {
                app.month = "all";
                app.year = "all";
            }
            else {
                var o = dateRange.options[dateRange.selectedIndex];
                app.month = o.dataset.month;
                app.year = o.dataset.year;
            }
            app.activeButton = 1;
        });

        var xhr = new XMLHttpRequest();
        xhr.addEventListener("load", function () {
            var news = JSON.parse(xhr.responseText);
            news.forEach(function (n) {
                n.newsPublicationDate = new Date(n.newsPublicationDate);
            });
            app.news = news;
        });

        xhr.open("GET", ajaxUrl);
        xhr.send();
    }

    if (document.getElementById("storyList") !== null) {
        
        var stories = JSON.parse(document.getElementById("storiesJson").textContent);

        var categories = storyCategories;
        var regions = storyRegions;

        if (!categories) {
            categories = {
                "all-state-development": "All state development",
                "all-tourism": "All tourism",
                "all-innovation": "All innovation",
                "advanced-manufacturing": "Advanced manufacturing",
                "advance-queensland": "Advance Queensland",
                "aqiaf": "AQIAF",
                "biofutures": "Biofutures",
                "biomedical": "Biomedical",
                "covid-19": "COVID-19",
                "defence": "Defence",
                "destinationQ": "DestinationQ",
                "development": "Development",
                "digital": "Digital",
                "ecotrails": "Ecotrails",
                "entrepreneurship": "Entrepreneurship",
                "great-barrier-reef": "Great Barrier Reef",
                "infrastructure-funding": "Infrastructure funding",
                "indigenous": "Indigenous",
                "industry-4.0": "Industry 4.0",
                "investment": "Investment",
                "jobs-and-regional-growth": "Jobs and regional growth",
                "manufacturing": "Manufacturing",
                "mets": "METS",
                "minjerribah-futures": "Minjerribah Futures",
                "priority-industries": "Priority industries",
                "qcn-fibre": "QCN Fibre",
                "queens-wharf": "Queens Wharf",
                "recovery": "Recovery",
                "research": "Research",
                "small-business": "Small business",
                "tourism-investment": "Tourism Investment",
                "travel": "Travel",
                "technology": "Technology",
                "torres-strait": "Torres Strait",
                "young-tourism-leaders": "Young Tourism Leaders"
            };
        }
        
        if (!regions) {
            regions = {
                "central_qld": "Central Queensland",
                "townsville": "Townsville",
                "logan": "Logan",
                "outback_qld": "Outback Queensland",
                "darling_downs": "Darling Downs",
                "gold_coast": "Gold Coast",
                "brisbane_redlands": "Brisbane and Redland",
                "ipswich": "Ipswich",
                "mackay_whitsunday": "Mackay\u2013Whitsunday",
                "sunshine_coast_moreton": "Sunshine Coast and Moreton Bay",
                "widebay": "Wide Bay",
                "far_north_qld": "Far North Queensland"
            }
        }
        

        var app = new Vue({
            el: "#storyContent",
            data: {
                length: stories.length,
                pageSize: 6,
                pageNum: 1,
                regions: regions,
                categories: categories,
                selectedRegion: "all",
                selectedCategory: "all"

            },
            computed: {
                items: function () {

                    var filtered = []
                    for (var i = 0; i < stories.length; ++i) {
                        var story = stories[i]
                        if ((this.selectedCategory == "all" || story.categories.includes(this
                                .selectedCategory)) &&
                            (this.selectedRegion == "all" || story.regions.includes(this
                                .selectedRegion))) {
                            filtered.push(story)
                        }
                    }

                    this.length = filtered.length;
                    var startIndex = (this.pageNum - 1) * this.pageSize;
                    var sliced = filtered.slice(startIndex, startIndex + this.pageSize);
                    return sliced;
                }
            },
            methods: {
                page: function (event) {
                    var text = event.target.textContent;
                    if (text == "Prev") {
                        --this.pageNum;
                        this.pageNum = Math.max(1, this.pageNum);
                    } else if (text == "Next") {
                        ++this.pageNum;
                        this.pageNum = Math.min(Math.ceil(this.length / this.pageSize), this
                            .pageNum);
                    } else {
                        this.pageNum = parseInt(text);
                    }

                    event.preventDefault();
                },

                filter: function (event) {
                    this.selectedCategory = document.getElementById("categorySelect").value;
                    this.selectedRegion = document.getElementById("regionSelect").value;
                    this.pageNum = 1;
                }
            }
        });
    }

});